import React from 'react';
import ConnectTo from '../../store/connect';

const Home = () => {
    React.useEffect(() => {
        window.location.href = 'https://plugins-v2.whitewall.dev/plugins/buildervariables';
    }, []);

    return (
        <div className="ph1 ph4-m ph5-ns pb5">
            Carregando...
        </div>
    );
};

Home.propTypes = {};

const mapStateToProps = (state, props) => ({
    ...props
});

export default ConnectTo(mapStateToProps)(Home);
